const setModal = () => {
  const open = document.querySelectorAll('[data-modal-open]');
  open.forEach(item => {
    if (document.getElementById(item.dataset.modalOpen)) {
      const target = document.getElementById(item.dataset.modalOpen);
      item.addEventListener('click', (event) => {
        event.preventDefault();
        target.open();
      })
    } else {
      console.warn('No target.')
    }
  })
  const close = document.querySelectorAll('[data-modal-close]');
  close.forEach(item => {
    if (document.getElementById(item.dataset.modalOpen)) {
      const target = document.getElementById(item.dataset.modalOpen);
      item.addEventListener('click', (event) => {
        event.preventDefault();
        target.close();
      })
    } else {
      console.warn('No target.')
    }
  })
}
setModal();

class ohrModal extends HTMLElement {
  constructor() {
    super();
    this.backdrop = null;
    this.querySelectorAll('.modal-close').forEach(item => {
      item.addEventListener('click', this.close.bind(this));
    })
    if (this.dataset.forceOpen && this.dataset.forceOpen.toLowerCase() === 'true') {
      this.open();
    }
  }
  toggleBackdrop (show = true) {
    if (!this.backdrop) {
      const backdrop = document.createElement('div');
      backdrop.className = 'toast-backdrop';
      this.appendChild(backdrop);
      this.backdrop = backdrop;
      backdrop.addEventListener('click', this.close.bind(this));
    } else {
      this.removeChild(this.backdrop);
      this.backdrop = null;
    }

  }
  open() {
    this.toggleBackdrop()
    this.classList.remove('hidden');
  }
  close() {
    this.toggleBackdrop()
    this.classList.add('hidden');
  }

}
customElements.define("ohr-modal", ohrModal);


class MainTab extends HTMLElement {
  constructor() {
    super();
    this.tabButton = this.querySelectorAll('.tab-item a');
    this.tabBody = this.querySelectorAll('.tab-body');
    this.init();
  }
  init() {
    this.tabButton.forEach(item => {
      item.addEventListener('click', this.setTab.bind(this));
    });
    this.tabBody.forEach((item, index) => {
      item.classList.toggle('hidden', index !== 0);
    })
  }
  setTab(event) {
    event.preventDefault();
    const index = parseInt(event.currentTarget.dataset.index);
    console.log(index)
    this.tabButton.forEach((item, idx) => {
      item.classList.toggle('active', idx === index);
    })
    this.tabBody.forEach((item, idx) => {
      item.classList.toggle('hidden', idx !== index);
    });
    const changeEvent = new CustomEvent('tab:changed', { detail: { tabIndex: index } });
    this.dispatchEvent(changeEvent);
  }
}
customElements.define('main-tab', MainTab);


document.addEventListener("DOMContentLoaded", () => {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const bundles = {};

      cart.items.forEach(item => {
        const bundleId = item.properties?._bundle_id;
        if (!bundleId) return;

        if (!bundles[bundleId]) {
          bundles[bundleId] = {
            master: null,
            items: []
          };
        }

        bundles[bundleId].items.push(item);
        if (item.properties.__bundle === 'true') {
          bundles[bundleId].master = item;
        }
      });

      const updates = {};

      Object.entries(bundles).forEach(([bundleId, data]) => {
        if (!data.master) {
          // No master item — remove all items from this bundle
          data.items.forEach(item => {
            updates[item.key] = 0;
          });
        }
      });

      if (Object.keys(updates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(() => {
          if (typeof refreshCartDrawer === 'function') {
            refreshCartDrawer();
          } else {
            location.reload();
          }
        });
      }
    })
    .catch(err => console.error("Error validating bundles in cart:", err));
});
